module.exports = __webpack_public_path__ + "media/images/terrasse-85c8fa2d184dec287ac0880b8dbfe612.svg";